
import ManageHotelRoute from '@/views/Hotel/ManageHotel/router'

import List from './List.vue'

export default [
  {
    path: '',
    name: 'HotelList',
    component: List
  },
  {
    path: '/',
    component: () => import(/* webpackChunkName: "hotelInfo" */ '@/views/Hotel/ManageHotel/Index.vue'),
    children: ManageHotelRoute
  }
]
